import * as React from 'react';
import { useSearch } from '@elastic/react-search-ui';
import classnames from 'classnames';
import { Config } from '../../helper';

export default function OpenSearchActiveFilters(props) {
  const { facets = [], hiddenFacets = [] } = props;

  const labelsMap = new Map();
  for (const facet of facets) {
    labelsMap.set(facet.field, facet.label);
  }

  const { filters, removeFilter } = useSearch();

  if (!filters.length) return null;

  return (
    <div className='active-filters'>
      {filters.map((filter) => {
        return filter.values.map((value) => {
          const cssClasses = classnames({
            'filter-chip': true,
            'filter-chip--inactive': hiddenFacets.includes(filter.field),
          });
          return (
            <span key={`${filter.field}:${value}`} className={cssClasses}>
              <span>
                <strong>{labelsMap.get(filter.field) || filter.field}:</strong> {value}
              </span>
              <button
                onClick={() => removeFilter(filter.field, value)}
                aria-label={Config.I18n.Filters.RemoveFilter(filter.field, value)}
              >
                ×
              </button>
            </span>
          );
        });
      })}
    </div>
  );
}
